import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import axios from 'axios';
import { fetchApiAuth } from '../utils/api';
import {
    GetLibraryRequest,
    CreateUpdateLibraryRequest,
    GetInternetFacilityRequest,
    CreateUpdateInternetFacilityRequest,
    GetTrainingReportRequest,
    CreateUpdateTrainingReportRequest,
    GetGoodPracticeRequest,
    CreateUpdateGoodPracticeRequest,
    GetConsultationRequest,
    CreateUpdateConsultationRequest,
    GetProjectsPartnershipRequest,
    CreateUpdateProjectsPartnershipRequest,
    GetExpertiseRequest,
    CreateUpdateExpertiseRequest,
    GetLeadershipManagementRequest,
    CreateUpdateLeadershipManagementRequest,
    GetPlanningAdministrationRequest,
    CreateUpdatePlanningAdministrationRequest,
    GetProgramsEvaluationRequest,
    CreateUpdateProgramsEvaluationRequest,
} from './types';

// Define ResponseProps type
interface ResponseProps {
    data: any;
}

// Library API functions
export const getLibrary = createAsyncThunk(
    'center-accreditation/get-library',
    async (payload: GetLibraryRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/get-library',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateLibrary = createAsyncThunk(
    'center-accreditation/create-or-update-library',
    async (payload: CreateUpdateLibraryRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/create-or-update-library',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

// Internet Facility API functions
export const getInternetFacility = createAsyncThunk(
    'center-accreditation/get-internet-facility',
    async (payload: GetInternetFacilityRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/get-internet-facility',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateInternetFacility = createAsyncThunk(
    'center-accreditation/create-or-update-internet-facility',
    async (payload: CreateUpdateInternetFacilityRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/create-or-update-internet-facility',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

// Training Report API functions
export const getTrainingReport = createAsyncThunk(
    'center-accreditation/get-training-report',
    async (payload: GetTrainingReportRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/get-training-report',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateTrainingReport = createAsyncThunk(
    'center-accreditation/create-or-update-training-report',
    async (payload: CreateUpdateTrainingReportRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/create-or-update-training-report',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

// Good Practice API functions
export const getGoodPractice = createAsyncThunk(
    'center-accreditation/get-good-practice',
    async (payload: GetGoodPracticeRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/get-good-practice',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateGoodPractice = createAsyncThunk(
    'center-accreditation/create-or-update-good-practice',
    async (payload: CreateUpdateGoodPracticeRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/create-or-update-good-practice',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

// Consultation API functions
export const getConsultation = createAsyncThunk(
    'center-accreditation/get-consultation',
    async (payload: GetConsultationRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/get-consultation',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateConsultation = createAsyncThunk(
    'center-accreditation/create-or-update-consultation',
    async (payload: CreateUpdateConsultationRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/create-or-update-consultation',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

// Projects Partnership API functions
export const getProjectsPartnership = createAsyncThunk(
    'center-accreditation/get-projects-partnership',
    async (payload: GetProjectsPartnershipRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/get-projects-partnership',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateProjectsPartnership = createAsyncThunk(
    'center-accreditation/create-or-update-projects-partnership',
    async (payload: CreateUpdateProjectsPartnershipRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/create-or-update-projects-partnership',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

// Education Center Data API functions
export const getAllSchoolsWithEducationCenterData = createAsyncThunk(
    'center-accreditation/get-all-schools-with-education-center-data',
    async () => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/get-all-schools-with-education-center-data',
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

// Expertise API functions
export const getExpertise = createAsyncThunk(
    'center-accreditation/get-expertise',
    async (payload: GetExpertiseRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/get-expertise',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateExpertise = createAsyncThunk(
    'center-accreditation/create-or-update-expertise',
    async (payload: CreateUpdateExpertiseRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/create-or-update-expertise',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

// Leadership Management API functions
export const getLeadershipManagement = createAsyncThunk(
    'center-accreditation/get-leadership-management',
    async (payload: GetLeadershipManagementRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/get-leadership-management',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateLeadershipManagement = createAsyncThunk(
    'center-accreditation/create-or-update-leadership-management',
    async (payload: CreateUpdateLeadershipManagementRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/create-or-update-leadership-management',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

// Planning Administration API functions
export const getPlanningAdministration = createAsyncThunk(
    'center-accreditation/get-planning-administration',
    async (payload: GetPlanningAdministrationRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/get-planning-administration',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdatePlanningAdministration = createAsyncThunk(
    'center-accreditation/create-or-update-planning-administration',
    async (payload: CreateUpdatePlanningAdministrationRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/create-or-update-planning-administration',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

// Programs Evaluation API functions
export const getProgramsEvaluation = createAsyncThunk(
    'center-accreditation/get-programs-evaluation',
    async (payload: GetProgramsEvaluationRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/get-programs-evaluation',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateProgramsEvaluation = createAsyncThunk(
    'center-accreditation/create-or-update-programs-evaluation',
    async (payload: CreateUpdateProgramsEvaluationRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/center-accreditation/create-or-update-programs-evaluation',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);
